
export default{
  //formata numeros de 00,000.00 para numeros com 00000,00
  //recebe um valor no formato 00,000.00
  //retorna uma string com virgula 00000,00
  //casasDecimais = valor padrão 2, se quiser 0 ou qualquer outro valor é só chmar na função  
  formataDolarToReal (valor,casasDecimais = 2) {
    let val = new String(valor.toFixed(casasDecimais));
    
    val = val.replace(",","");
    val = val.replace(".","");
    //val = val.replace(/^(\d{1,3}(\.\d{3})*|\d+)(\,\d{2})?$/ );
    

    //http://wbruno.com.br/expressao-regular/formatar-em-moeda-reais-expressao-regular-em-javascript/
    let tmp = val+'';
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
    if( tmp.length > 6 )
        tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

    return tmp;
  },

  //formata numeros de 00,000.00 para numeros com 00000,00
  //recebe um valor no formato 00.000,00
  //retorna um numero com virgula 00000.00  
  //casasDecimais = valor padrão 2, se quiser 0 ou qualquer outro valor é só chmar na função
  formataRealToDolar (valor,casasDecimais=2) {
    let val = new String(valor);
    val = val.replace(".","");
    val = val.replace(".","");
    val = val.replace(",",".");
    val = Number(val)
    return val.toFixed(casasDecimais);
  },
  isPermissao() {
    let permissao = [];
    try {
      const token = localStorage.getItem("token");
      if (!token) 
        throw new Error('Token não encontrado no localStorage')
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
      atob(base64)
          .split("")
          .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      const payload = JSON.parse(jsonPayload);
      permissao = payload.permissao || [];
    } catch (error) {
      console.error("Erro ao processar o token:", error);
    }        
    return permissao;
  },
  getUsuario() {
    try {
      const token = localStorage.getItem('token')
      if (!token) 
        throw new Error('Token não encontrado no localStorage')

      const payloadBase64 = token.split('.')[1]
      const payloadJson = atob(payloadBase64)
      const payload = JSON.parse(payloadJson)
      const dados = {
        id_usuario: payload.sub,
        id_fabricante: payload.id_fabricante,
        id_users_superior: payload.id_users_superior,
        id_nivel: payload.id_nivel,
        id_grupo: payload.id_grupo
      }
      return dados
    } catch (e) {
      console.error('Erro ao decodificar JWT:', e.message)
      return null
    }
  }



}

//Catana Rahmeier
//Funções úteis para todo o sistema
//25/09/2020 - versão 1

//estes comentários são para melhorar a função mais tarde Catana 25/09/2020
// FuncoesUteis.install = function (Vue, options) {
//   // 1. Adicionando um método global
//   //formata numeros de 00,000.00 para numeros com 00000,00
//   //recebe um valor no formato 00.000,00
//   //retorna um numero com virgula 00000.00  
//   Vue.formataRealToDolar = function (valor) {
//     let val = new String(valor);
//     val = val.replace(".","");
//     val = val.replace(".","");
//     val = val.replace(",",".");
//     return Number(val);
//   }

//   // // 2. Adicionando uma diretiva
//   // Vue.directive('my-directive', {
//   //   bind (el, binding, vnode, oldVnode) {
//   //     // some logic ...
//   //   }
//   // //  // ...
//   // });
//   // // 3. Adicionando um método ao protótipo
//   // Vue.prototype.$myMethod = function (methodOptions) {
//   //   // some logic ...
//   // }
// }
